/**
 * PATH: apps/quote/src/components/builder/panels/takeoff-assist/takeoff-assist-types.ts
 * PURPOSE: Types and constants for the Takeoff Assist panel
 */

import { Target, Layers, Package, TrendingUp } from 'lucide-react'
import type { QuoteSection, DocumentExtractedItem, TakeoffCoverageGap } from '@/lib/quoteApi'

export type AssistTab = 'search' | 'suggestions' | 'documents' | 'history'

export interface QuickFilter {
  id: string
  label: string
  icon: React.ComponentType<{ className?: string }>
  query: string
}

export interface TakeoffAssistPanelProps {
  quoteId: string
  sections: QuoteSection[]
  selectedSectionId?: string | null
  selectedItemId?: string | null
  onApplyApplication: (sectionId: string, itemId: string, applicationId: string) => void
  onJumpToRow: (sectionId: string, itemId: string) => void
  onAddRow: (sectionId: string, applicationId: string) => void
  onAddRowWithDetails?: (
    sectionId: string,
    details: {
      description: string
      quantity?: number
      unit?: string
      location?: string
      source_document_id?: string
    }
  ) => void
}

export const QUICK_FILTERS: QuickFilter[] = [
  { id: 'exterior', label: 'Exterior', icon: Target, query: 'exterior' },
  { id: 'interior', label: 'Interior', icon: Layers, query: 'interior' },
  { id: 'steel', label: 'Steel', icon: Package, query: 'steel' },
  { id: 'timber', label: 'Timber', icon: Package, query: 'timber' },
  { id: 'concrete', label: 'Concrete', icon: Package, query: 'concrete' },
  { id: 'high-build', label: 'High Build', icon: TrendingUp, query: 'high build' },
]
